import { connect } from 'react-redux';

import StepRoomInformation from './StepRoomInformation';

const mapStateToProps = (state) => ({
  setting: state.Setting.setting,
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(StepRoomInformation);
